import type { FC } from 'react';
import { StyleSheet } from 'react-native';
import { unstable_createElement as createElement } from 'react-native-web';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	title: string;
	videoId: string;
}

const YoutubePlayerView: FC<Props> = ({ title, videoId }: Props) =>
	createElement('iframe', {
		title,
		src: `${Constants.urlYoutubeEmbed}${videoId}?autoplay=1`,
		allowFullScreen: true,
		allow: 'autoplay',
		style: styles.player,
	});

const styles = StyleSheet.create({
	player: {
		...StyleSheet.absoluteFill,
		width: '100%',
		height: '100%',
		borderWidth: Dimens.borderWidth0,
	},
});

export default YoutubePlayerView;
